import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Autocomplete, Button, TextField } from "@mui/material";
import CustomModal from "../../../common-utilities/core/modal";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { FINANCE_V2_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { FINANCE_REST_URLS } from "../../../common-utilities/utils/end-points/finance-v2";
import { PO_TYPES } from "./helper";
import { clearProperty } from "../../../common-utilities/utils/misc";
import FinancialYearDropdown from "../home/financial-year-dropdown";
// import { isProcurementUser, isRestrictedCategoryName } from "../../utils/common-utils";
import {
  canUseProcurementBudgetForIndependentPO,
  isRestrictedCategoryName,
} from "../../utils/common-utils";

const IndependentPOModal = ({ onClose, mainTabIndex, value }) => {
  const navigate = useNavigate();
  const [formDetails, setFormDetails] = useState({});
  const [budgetLineItems, setBudgetLineItems] = useState([]);
  const [sites, setSites] = useState([]);
  const { site = "", lineItems = [], poType = {} } = formDetails;
  const lineItemIds = lineItems.map((l) => l.id);

  const loadSites = (poType) => {
    let url = `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.LOCATIONS}/list`;
    let params = {
      poType,
      budgetStatus: "approved",
      financialYear: formDetails?.financialYear,
    };

    clearProperty("site", setFormDetails);
    invokeApi(HTTP_METHODS.GET, url, null, params)
      .then((response) => {
        if (response.message) {
        } else {
          const results =
            response?.map?.((item) => {
              return {
                ...item,
                restaurantId: item.code,
                restaurantName: item.name,
                id: item.id,
              };
            }) || [];
          setSites(response || []);
        }
      })
      .catch((err) => {});
  };

  const loadBudgets = (site, budgetType) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_BUDGETS}`,
      null,
      {
        page: 1,
        status: "approved",
        site,
        limit: 1000,
        budgetType,
        dropdown: true,
        financialYear: formDetails?.financialYear,
      }
    )
      .then((response) => {
        if (response.message) {
        } else if (response.totalResults > 0) {
          // Procurement Budget / Procurement Budget Opex are P&SC-only (see
          // canConvertPRToPO/RESTRICTED_CATEGORY_NAMES) -- a non-P&SC user gets these two
          // line items dropped from the list entirely, not just disabled, since they have no
          // valid reason to ever select them and the backend rejects the submission anyway.
          const approvedLineItems = response.results[0].lineItems.filter(
            (l) => l.status === "approved"
          );
          // setBudgetLineItems(
          //   isProcurementUser()
          //     ? approvedLineItems
          //     : approvedLineItems.filter((l) => !isRestrictedCategoryName(l.name))
          // );
          setBudgetLineItems(
            canUseProcurementBudgetForIndependentPO()
              ? approvedLineItems
              : approvedLineItems.filter((l) => !isRestrictedCategoryName(l.name))
          );
        }
      })
      .catch((err) => {});
  };

  const isDisabled = () => {
    return !poType || !site || !lineItems || lineItems.length === 0;
  };

  const onCreate = () => {
    let budgetId = "";
    if (lineItems.length > 0) {
      budgetId = lineItems[0].budgetId;
    } else {
      return;
    }

    navigate(
      `purchase-order/create/${budgetId}?poType=${
        poType.value
      }&lineItemIds=${lineItemIds.join(
        ","
      )}&index=${mainTabIndex}&subIndex=${value}`
    );
  };

  return (
    <CustomModal
      title="Create Purchase Order"
      disabledOutsideClick={true}
      onClose={() => {
        setFormDetails({});
        onClose();
      }}
    >
      <div className="finance-v2-po-modal-content">
        <FinancialYearDropdown
          filters={formDetails}
          setFilters={setFormDetails}
          isFullWidth={true}
        />
        <Autocomplete
          value={formDetails.poType || ""}
          onChange={(e, val) => {
            if (val) {
              loadSites(val.value);
              setFormDetails((prevVal) => ({ ...prevVal, poType: val }));
            } else {
              setFormDetails({});
            }
          }}
          renderInput={(params) => (
            <TextField {...params} size="small" label="PO Type *" />
          )}
          options={PO_TYPES}
        />
        <Autocomplete
          onChange={(e, val) => {
            if (val) {
              setFormDetails({
                ...formDetails,
                site: val,
                lineItems: [],
              });

              loadBudgets(
                val.id,
                formDetails?.poType?.value === "opex_po"
                  ? "opex_budget"
                  : "capex_budget"
              );
            } else {
              setFormDetails({
                ...formDetails,
                lineItems: [],
                site: null,
              });
              setBudgetLineItems([]);
            }
          }}
          value={formDetails.site || {}}
          getOptionLabel={(op) =>
            `${op.code || ""} - ${op.name || ""}` || ""
          }
          renderInput={(params) => (
            <TextField {...params} size="small" label="Site Name *" />
          )}
          options={sites}
        />
        <Autocomplete
          onChange={(e, val) => {
            if (val) {
              setFormDetails({
                ...formDetails,
                budgetId: val.budgetId,
                lineItems: val,
              });
            } else {
              setFormDetails({
                ...formDetails,
                lineItems: {},
              });
            }
          }}
          multiple
          value={formDetails.lineItems || []}
          getOptionLabel={(op) => op.name || ""}
          renderInput={(params) => (
            <TextField {...params} size="small" label="Budget Category" />
          )}
          options={budgetLineItems}
        />

        <Button variant="outlined" onClick={onCreate} disabled={isDisabled()}>
          Create Order
        </Button>
      </div>
    </CustomModal>
  );
};

export default IndependentPOModal;
